import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  BidderDetailArrayModel,
  BidderDetailModel,
} from "../../models/BidderDetailModel";

const initialState: BidderDetailArrayModel = {
  bidderDetails: [],
};
const BidderDetailSlice = createSlice({
  name: "BidderDetail",
  initialState: initialState,
  reducers: {
    setBidderDetails(state, action: PayloadAction<BidderDetailModel[]>) {
      state.bidderDetails = action.payload;
    },
  },
});
export default BidderDetailSlice;
